<script lang="ts">
  import { validityEvent } from '../../../../common/util';
  import SingleStar from './SingleStar.svelte';

  export let rating = 0;
  export let readOnly;

  const rateArray = [1, 2, 3, 4, 5];
  let hover = 0;
  let hiddenInput;

  function handleStarClick(ra) {
    if (!readOnly) {
      rating = ra;
      hiddenInput.value = rating;
      hiddenInput.dispatchEvent(new Event('input'));
    }
  }
  function handleStarHover(ra) {
    if (!readOnly) {
      hover = ra;
    }
  }
</script>

<input
  required
  style="display:none"
  use:validityEvent
  on:validityChange
  type="number"
  bind:this={hiddenInput}
  min="1"
  max="5"
/>

<section class="star-rating-container" on:mouseleave={() => (hover = 0)}>
  {#each rateArray as ra}
    <SingleStar
      {readOnly}
      filled={rating >= ra}
      hover={hover >= ra}
      on:click={() => handleStarClick(ra)}
      on:mouseover={() => handleStarHover(ra)}
    />
  {/each}
</section>

<style lang="scss">
  .star-rating-container {
    display: flex;
    gap: 20px;
    align-items: center;
  }
</style>
